import type { SpeechLanguage } from "../../types/audio";

export type SttBackendName = "web-speech" | "azure" | "gradium";

export const STT_BACKEND_NAMES: readonly SttBackendName[] = ["web-speech", "azure", "gradium"];

export const isSttBackendName = (value: unknown): value is SttBackendName =>
  typeof value === "string" && (STT_BACKEND_NAMES as readonly string[]).includes(value);

export interface SttEndMeta {
  /** True when the session ended because the silence timer fired (vs an explicit stop). */
  viaTimeout: boolean;
}

export interface SttRecognitionOptions {
  language: SpeechLanguage;
  /** Inter-result silence: how long to wait after the last interim/final transcript
   *  before ending the session. Reset on every result. */
  silenceTimeout: number;
  /** Pre-speech grace: how long to wait for the first transcript to arrive after
   *  the mic opens. Defaults to max(silenceTimeout, 10000) when omitted. Prevents
   *  the short silenceTimeout from killing the session before the user has started
   *  speaking. */
  noSpeechTimeout?: number;
  onStart?: () => void;
  onInterimResult?: (text: string) => void;
  onFinalResult?: (text: string) => void;
  onEnd?: (meta: SttEndMeta) => void;
  onError?: (err: Error) => void;
}

export interface SttBackend {
  name: SttBackendName;
  isSupported(): Promise<boolean>;
  startRecognition(opts: SttRecognitionOptions): Promise<void>;
  stopRecognition(): Promise<void>;
}
